import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { currencyRegistry } from '@root/entities/currency/atoms'
import { Network } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { apiRequest } from '@root/shared/api'

import { BlacklistCurrencyMeta } from '../model'

import type { CurrencyAddress } from '@root/entities/currency'
import type { PairAddress } from '@root/entities/pair'

export const fetchBlacklistTokensMetaRequestAction = action(
  async (ctx, { network }: { network: Network.Network }) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userHiddenTokensList, [
        {
          network: Network.toDto(network),
        },
      ]),
    )

    return pipe(
      result,
      Result.map((it) =>
        it.map((it) => {
          const currency = it.meta
            ? currencyRegistry.resolveFromTokenMeta(ctx, it.meta)
            : undefined

          return BlacklistCurrencyMeta.fromDto(it, currency)
        }),
      ),
    )
  },
  'fetchBlacklistTokensMetaRequestAction',
)

export const hideTokenRequestAction = action(
  async (
    ctx,
    {
      network,
      tokenAddress,
      poolAddress,
    }: {
      network: Network.Network
      tokenAddress: CurrencyAddress
      poolAddress?: PairAddress
    },
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userHiddenTokensCreate, [
        {
          network: Network.toDto(network),
          tokenAddress,
          poolAddress,
        },
      ]),
    )

    return result
  },
  'hideTokenRequestAction',
)

export const unhideTokenRequestAction = action(
  async (
    ctx,
    {
      network,
      tokenAddress,
    }: {
      network: Network.Network
      tokenAddress: CurrencyAddress
    },
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userHiddenTokensDelete, [
        {
          network: Network.toDto(network),
          tokenAddress,
        },
      ]),
    )

    return result
  },
  'unhideTokenRequestAction',
)
